import { Body, LayoutGrid, Notification, Section } from '@innovationnorway/component-library';
import { ReactNode, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../context/app-context';
import { useLocalizer } from '../hooks';
import { useMinSideLink } from '../hooks/useGetMinSideLink';
import { apiClient } from '../lib/query/apiClient';
import { TasksList } from '../pages/Home/TasksList';
import AppBreadcrumbs from './AppBreadcrumbs';
import { Footer } from './Footer';
import { Header } from './Header';
import { ConditionalRender } from './Layout/ConditionalRender';
import { NavMenu } from './NavMenu';
import { ServiceMessageList } from './ServiceMessageList/ServiceMessageList';
import { ActionCards } from './Shared/ActionCards/ActionCards';
import { LoadingSpinner } from './Shared/LoadingSpinner/LoadingSpinner';

export const mainNavMenu = ['/bankaccounts', '/casemanagement'];

// TODO refactor layout so it is a layout component and not a page component
export const Layout = (props: { children: ReactNode }) => {
  const { state } = useContext(AppContext);

  const { globalL } = useLocalizer('Navigation');

  // TODO refactor layout so we don't need to maintain this logic
  const location = useLocation();
  const showNavItems = mainNavMenu.find((l) => l === location.pathname) !== undefined;
  const { data: configurationData } = apiClient.useQuery('get', '/api/v1/Session/current/configuration');
  const minSideLink = useMinSideLink();

  // If the user is not verified, we redirect them to MinSide's unverified page
  if (configurationData?.user?.isContactInformationVerified === false && minSideLink?.url) {
    window.location.assign(`${minSideLink.url}/unverified`);
  }

  // If the user is on the error page, we don't show service messages
  const shouldShowServiceMessages = location.pathname !== '/error';

  // If the user has no roles and contact information is verified, we hide navigation items and show a message that they have no roles and how to get them.
  if (configurationData?.user?.hasRoles === false && configurationData?.user?.isContactInformationVerified) return <UserHasNoRoles />;

  return (
    <AppContext.Consumer>
      {() => (
        <div className="flex flex-col h-screen min-h-screen bg-white">
          <div className="flex-1 shrink-0">
            <Header />
            <ConditionalRender>
              {shouldShowServiceMessages && <ServiceMessageList />}

              {showNavItems && (
                <>
                  <AppBreadcrumbs currentPageName={globalL('pageTitle')} />
                  <h1 className="mt-2.5">{globalL('pageTitle')}</h1>

                  <ActionCards />

                  <TasksList />

                  <NavMenu />
                </>
              )}

              {/* TODO can be replaced with suspense in the future, which is already present in parent component, App.tsx */}
              {state.application.loading ? <LoadingSpinner /> : props.children}
            </ConditionalRender>
          </div>
          <div className="shrink-0">
            <Footer />
          </div>
        </div>
      )}
    </AppContext.Consumer>
  );
};

// TODO once layout has been refactored, move this a lower level component
export function UserHasNoRoles() {
  const { globalL } = useLocalizer('');

  return (
    <div className="flex flex-col h-screen min-h-screen bg-white">
      <div className="flex-1 shrink-0">
        <Header />
        <Body id="main-content">
          <Section>
            <LayoutGrid className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-12">
              <div className="w-full col-span-4 mx-auto sm:col-span-4 md:col-span-8 lg:col-start-2 lg:col-end-12">
                <h1 className="mt-2.5">{globalL('pageTitle')}</h1>

                <Notification className="noClearance" type="info">
                  <span className="whitespace-pre-line">{globalL('noClearanceToSeeFinancialSupportForCompany')}</span>
                </Notification>
              </div>
            </LayoutGrid>
          </Section>
        </Body>
      </div>
      <div className="shrink-0">
        <Footer />
      </div>
    </div>
  );
}
